export default __webpack_public_path__ + "static/media/header-worker.e3ab0570.webp";